<script>

import Order from "../../models/Order"
import OrderDetailTable from "./OrderDetailTable"
import {action} from "../../store/types";
import {mapActions} from "vuex";
import OverlayLoading from "../Admin/OverlayLoading";
import UserOrderStatus from "./UserOrderStatus";
import CheckoutForms from "../checkout/CheckoutForms";
import User from "../../models/User";
import OrderHistory from "../../models/OrderHistory";
import UserAddress from "../../models/UserAddress";
import ConfirmModal from "../ConfirmModal";
import {getAlertMessage, getValidationMessage} from "../../utility/validateUtility";
import PriceBox from "../PriceBox";
import OrderItem from "../../models/OrderItem";
import linq from 'linq'
import Form, {HasError} from "vform";

export default {
    name: 'order-detail-edit',

    data () {
        return {
            approvalForm: new Form({
                approval: false,
            }),
            order: new Order(),
            user: new User(),
            orderHistoryForm: new OrderHistory(),
            orderItems: [],
            errorMessage: '',
            isOnlyCharter: false,
            isLoading: false,
            carts: [],
        }
    },

    props: {
        data:{}
    },

    computed: {
    },

    created() {

    },

    mounted() {
        this.order = new Order({...eval(this.data).order})
        this.user = new User({...eval(this.data).user})
        this.orderItems = [...this.order.latestOrderHistory.orderItems]
        this.carts = eval(this.data).carts
        for (const item of this.orderItems) {
            if (item.isOnlyCharter) {
                this.isOnlyCharter = true;
                break;
            }
        }
        this.setOrderData()
    },

    methods: {
        ...mapActions([
            action.LOADING_UPDATE,
        ]),

        setOrderData() {
            const orderData = new OrderHistory({
                ...this.order.latestOrderHistory,
                firstName: this.user.firstName,
                familyName: this.user.familyName,
            });
            this.updateForm(orderData)
            console.log(this.orderHistoryForm)
        },

        updateForm(val) {
            this.orderHistoryForm = new OrderHistory({...val})
        },

        async update() {
            this.errorMessage = ''
            this.orderHistoryForm.orderItems = this.orderItems
            this.isLoading = true
            try {
                const { data } = await this.orderHistoryForm.post(`/api/mypage/order/update?approval=${this.approvalForm.approval}`)
                if(data.okPath) {
                    window.location.href = data.okPath
                }
            } catch (e) {
                setTimeout(() => {
                    $(window).scrollTop(0)
                },500)
                const error = this.orderHistoryForm.form.errors.errors
                this.errorMessage = getAlertMessage(e, '項目に不備があります。ご確認ください。')

                let _address = new UserAddress({...this.orderHistoryForm.orderUserAddress})
                _address.form.errors.set({...error})
                this.approvalForm.errors.set({...error})
                this.orderHistoryForm = new OrderHistory({
                    ...this.orderHistoryForm,
                    orderUserAddress: _address
                })
                if(this.orderHistoryForm.form.errors.errors.hasOwnProperty('rental_period_validate')) {
                    this.errorMessage = '1年を超えるレンタル期間は設定できません。1年以上のレンタルをご希望の方は、<a href="mailto:{{config(\'app.mail.from.address\')}}?subject=【お問い合わせ】株式会社ワールドサービス partycreation WEB担当宛">こちら</a>よりお問い合わせ下さい。'
                }
            } finally {
                this.isLoading = false
            }
        },

        async onAddProduct() {
            this.errorMessage = ''
            this.isLoading = true
            try {
                const {data} = await this.orderHistoryForm.post('/api/order/cartToItem')
                const arr = linq.from(data)
                    .select(x => new OrderItem(x))
                    .where(x => {
                        const tmp = linq.from(this.orderItems).select(item => item.itemId).toArray()
                        return !tmp.includes(x.item.id)
                    })
                    .toArray()
                console.log(arr)
                // const addCart = arr.filter(x => {
                //     this.orderItems.map(item => item.id).includes(x.id)
                // })
                // console.log(addCart)
                this.orderItems = this.orderItems.concat(arr)
            } catch (e) {
                setTimeout(() => {
                    $(window).scrollTop(0)
                },500)
                this.errorMessage = getValidationMessage(e)
            } finally {
                this.isLoading = false
            }
        },

        deleteItem(i) {
            this.orderItems = this.orderItems.filter((x,_i) => _i !== i)
        },

        async reOrder() {
            this.isLoading = true
            const arr = this.order.order.orderItems.map(x => x.getPostable())
            await axios.post('/api/cart/add', arr)
            window.location.href = '/cart'
            this.isLoading = false
        },

        goBack() {
            window.location.href = `/mypage/order/detail/${this.order.encryptCode}`
        },

        async onCalc() {
            this.isLoading = true
            try {
                console.log(this.orderHistoryForm)
                this.orderHistoryForm.orderItems = this.orderItems
                const { data } = await this.orderHistoryForm.post(`/api/order/calculation?approval=${this.approvalForm.approval}`)
                this.orderHistoryForm = new OrderHistory({
                    ...this.orderHistoryForm,
                    ...data,
                })
            } catch (e) {
                setTimeout(() => {
                    $(window).scrollTop(0)
                },500)
                const error = this.orderHistoryForm.form.errors.errors
                console.log(error)
                this.errorMessage = getAlertMessage(e, '項目に不備があります。ご確認ください。')

                let _address = new UserAddress({...this.orderHistoryForm.orderUserAddress})
                _address.form.errors.set({...error})
                this.approvalForm.errors.set({...error})
                this.orderHistoryForm = new OrderHistory({
                    ...this.orderHistoryForm,
                    orderUserAddress: _address
                })
            } finally {
                this.isLoading = false
            }
        }
    },

    components: {
        OrderDetailTable,
        OverlayLoading,
        UserOrderStatus,
        CheckoutForms,
        ConfirmModal,
        PriceBox,
        HasError,
    },
}
</script>

<style lang="scss" scoped>
.status-alert {
    font-weight: bold;
    padding: 0 15px;
    border-radius: 5px;
    font-size: 21px;
}
.btn-sm {
    padding: 5px 14px;
}
.trash-btn {
    padding: 5px;
    font-size: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/order/OrderDetailEdit.vue